import React from 'react';
import PremiumLoader from './PremiumLoader';

/** @deprecated Prefer PremiumLoader — kept for existing imports */
const ConsistentLoader = ({
  message = 'Loading your creative journey…',
  size = 'large',
  showBackground = true,
}) => {
  if (!showBackground) {
    return <PremiumLoader message={message} variant="minimal" />;
  }
  return <PremiumLoader message={message} variant="fullscreen" />;
};

export default ConsistentLoader;
